export function isBoolean(value) {
  return typeof value === 'boolean';
}
export function oneOf(values) {
  function typeGuard(value) {
    return values.includes(value);
  }
  /**
   * This is used by test utils to get the variants when running describe.each
   */
  if (IS_TESTING_ENV) {
    typeGuard.values = values;
  }
  return typeGuard;
}

// @ts-ignore

var IS_TESTING_ENV = process.env.NODE_ENV === 'test' || process.env.JEST_WORKER_ID !== undefined;